export const baseButtonStyle = {
  minHeight: "40px",
  fontSize: "15px",
  fontWeight: 700,
  justifyContent: "flex-start",
  borderRadius: "12px",
  padding: "8px 16px",
};

export const deleteButtonStyle = {
  color: "white",
  backgroundColor: "#c45353",
};

export const groupListStyle = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  gap: "12px",
  padding: "10px 14px",
  borderRadius: "14px",
  backgroundColor: "rgba(47, 93, 140, 0.06)",
  border: "1px solid rgba(47, 93, 140, 0.1)",
  marginBottom: "8px",
  flexWrap: "wrap",
};

export const groupNameStyle = { fontSize: "15px", fontWeight: 700 };

export function getTaskStyle(drawTopBorder) {
  return drawTopBorder
    ? {
        border: "1px solid rgba(47, 93, 140, 0.12)",
        borderTop: "1px solid rgba(47, 93, 140, 0.12)",
        backgroundColor: "#fff",
        borderRadius: "12px",
        marginBottom: "6px",
        boxShadow: "none",
      }
    : {
        border: "1px solid rgba(47, 93, 140, 0.12)",
        backgroundColor: "#fff",
        borderRadius: "12px",
        marginBottom: "6px",
        boxShadow: "none",
      };
}
